// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../media/images/world.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-header {
  background: none !important;
  line-height: 0 !important;
  position: fixed;
  z-index: 100;
  height: 100px !important;
  padding: 0 !important;
  width: 100%;
  backdrop-filter: blur(10px);
}
.header-container {
  max-width: 1480px;
  margin: 0 auto;
}

.header {
  background: none !important;
  align-items: center;
  padding: 15px 20px;
  margin: 20px 16px;
  justify-content: space-between;
}

.header-buttons {
  gap: 8px;
  display: flex;
  text-align: center;
}

@media screen and (min-width: 1025px) and (max-width: 1330px) {
  .header-buttons .language-btn {
    width: 142px;
  }

  .header-menu .menu { 
    gap: 16px;
  }
}

@media screen and (max-width: 1024px) {
  .header {
    margin: 0;
  }

  .header-buttons .header-contact-btn {
    display: none;
  }

  .header-menu .menu { 
    gap: 8px;
  }

  .menu-content {
    width: 450px !important;
  }

  .menu-content-left { 
    padding: 50px 24px !important;
  }

  .menu-content-right {
    padding: 50px 0 !important;
  }

  .submenu-item {
    white-space: normal !important;
  }
}

@media screen and (max-width: 1024px) {
  .header {
    border: 0.5px solid #FFF;
    border-radius: 100px;
    justify-content: space-around;
    margin: 20px 16px;
  }
  .ant-layout-header:has(.header.show) {
    background-color: #eeeeee !important;
  }
}

.header > ul {
  background: none !important;
  border-bottom: none !important;
}

.logo {
  height: 36px;
}

/* Lista principal del menú */
.menu {
  list-style: none;
  display: flex;
  gap: 24px;
  padding: 0;
  margin: 0;
}

/* Elementos del menú principal */
.menu-item {
  position: relative;
  cursor: pointer;
}

/* Ocultación de blog y prensa */

.menu-item:nth-last-child(1) {
  /* display: none; */
}

.mobile-menu-content .ant-collapse .ant-collapse-item:last-child {
  display: none;
}
/*  */

.menu-item > span {
  font-size: 16px;
  color: #0027f9;
  text-transform: capitalize;
  font-weight: 500;
}

.menu-link {
  text-decoration: none;
  color: #0027F9 !important;
  position: relative;
}


/* Submenú */
.submenu {
  list-style: none;
  top: 100%;
  left: 0;
  padding: 20px 0;
  margin: 0;
}

/* Elementos del submenú */
.submenu-item {
  padding: 20px 20px;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}

.submenu-item:hover {
  background-color: #f0f0f0;
  color: #0027f9 !important;
}

.submenu-link {
  text-decoration: none;
  color: #0027F9 !important;
  font-weight: 400;
}

.menu-content {
  display: flex;
  position: absolute;
  top: 150%;
  left: -50px;
  background: #fff;
  border-radius: 32px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 1000;
  width: 700px;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.3s, opacity 0.3s;
}

.menu-item:hover .menu-content {
  visibility: visible;
  opacity: 1;
}

.menu-item:hover .menu-link::after {
  visibility: visible;
  opacity: 1;
}

.menu-content-left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  text-align: left;
  padding: 50px 40px;
  background: rgba(246, 246, 246, 0.90);
  max-width: 300px;
}

.menu-content-left-title {
  color: #0027F9;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
  letter-spacing: -0.352px;
}

.menu-logo {
  width: 130px;
  border-radius: 16px;
  margin-bottom: 10px;
}

.menu-title {
  font-weight: bold;
  margin-bottom: 5px;
  color: #0027F9;
}

.menu-description {
  font-size: 14px;
  /* color: #555; */
}

.menu-content-right {
  display: flex;
  flex-direction: column;
  background: rgba(254, 254, 254, 0.9);
  backdrop-filter: blur(20px);
  padding: 50px 40px;
}

.menu-curve {
  position: absolute;
  bottom: -25px; /* Ajusta esta distancia para alinear con el menú */
  left: 0;
  width: 100%;
  height: 25px;
  overflow: hidden;
}

.menu-curve svg {
  display: block;
  width: 100%;
  height: auto;
}

.mobile-menu-actions .login-btn {
  height: 64px;
}

.header-buttons .button-yellow-sm-500, .header-buttons .login-btn, .header-buttons .language-btn {
  height: 40px;
}


.header-buttons .language-btn .ant-select-selection-item::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  display: inline-block;
  position: relative;
  top: 3px;
}

.language-btn > .ant-select-selector {
  color: #0027F9;
}

.header-buttons .language-btn .ant-select-selection-item::after, .mobile-menu-actions .language-btn .ant-select-selection-item::after {
  content: ">";
  margin-left: 8px;
  transform: rotate(90deg);
  display: inline-block;
  font-size: 16px;
}

/* Ancho y espaciado general */
.menu-content.markets-menu .menu-content-right {
  display: flex;
  gap: 40px;
}

/* Cada columna de región */
.region-column {
  flex: 1 1;
}

/* Título de la región */
.region-column-title {
  color: #0027F9;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
  text-transform: uppercase;
}

/* Lista de mercados dentro de la región */
.region-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.region-items .submenu-item {
  padding: 8px 0;
}


/* Título de la región */
.region-column-title {
  color: #0027F9;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
  text-transform: uppercase;
}

/* Grid de 3 columnas para los países */
.region-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 24px;  /* fila x columna */
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Ajustes a cada elemento de país */
.region-grid .submenu-item {
  padding: 4px 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/Header.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;IACpB,6BAA6B;IAC7B,iBAAiB;EACnB;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gCAAgC;;AAEhC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA,KAAK;;AAEL;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA,YAAY;AACZ;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,eAAe;EACf,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa,EAAE,mDAAmD;EAClE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,WAAW;EACX,yDAAkD;EAClD,wBAAwB;EACxB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,SAAO;AACT;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;;AAGA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc,GAAG,mBAAmB;EACpC,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB","sourcesContent":[".ant-layout-header {\n  background: none !important;\n  line-height: 0 !important;\n  position: fixed;\n  z-index: 100;\n  height: 100px !important;\n  padding: 0 !important;\n  width: 100%;\n  backdrop-filter: blur(10px);\n}\n.header-container {\n  max-width: 1480px;\n  margin: 0 auto;\n}\n\n.header {\n  background: none !important;\n  align-items: center;\n  padding: 15px 20px;\n  margin: 20px 16px;\n  justify-content: space-between;\n}\n\n.header-buttons {\n  gap: 8px;\n  display: flex;\n  text-align: center;\n}\n\n@media screen and (min-width: 1025px) and (max-width: 1330px) {\n  .header-buttons .language-btn {\n    width: 142px;\n  }\n\n  .header-menu .menu { \n    gap: 16px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .header {\n    margin: 0;\n  }\n\n  .header-buttons .header-contact-btn {\n    display: none;\n  }\n\n  .header-menu .menu { \n    gap: 8px;\n  }\n\n  .menu-content {\n    width: 450px !important;\n  }\n\n  .menu-content-left { \n    padding: 50px 24px !important;\n  }\n\n  .menu-content-right {\n    padding: 50px 0 !important;\n  }\n\n  .submenu-item {\n    white-space: normal !important;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .header {\n    border: 0.5px solid #FFF;\n    border-radius: 100px;\n    justify-content: space-around;\n    margin: 20px 16px;\n  }\n  .ant-layout-header:has(.header.show) {\n    background-color: #eeeeee !important;\n  }\n}\n\n.header > ul {\n  background: none !important;\n  border-bottom: none !important;\n}\n\n.logo {\n  height: 36px;\n}\n\n/* Lista principal del menú */\n.menu {\n  list-style: none;\n  display: flex;\n  gap: 24px;\n  padding: 0;\n  margin: 0;\n}\n\n/* Elementos del menú principal */\n.menu-item {\n  position: relative;\n  cursor: pointer;\n}\n\n/* Ocultación de blog y prensa */\n\n.menu-item:nth-last-child(1) {\n  /* display: none; */\n}\n\n.mobile-menu-content .ant-collapse .ant-collapse-item:last-child {\n  display: none;\n}\n/*  */\n\n.menu-item > span {\n  font-size: 16px;\n  color: #0027f9;\n  text-transform: capitalize;\n  font-weight: 500;\n}\n\n.menu-link {\n  text-decoration: none;\n  color: #0027F9 !important;\n  position: relative;\n}\n\n\n/* Submenú */\n.submenu {\n  list-style: none;\n  top: 100%;\n  left: 0;\n  padding: 20px 0;\n  margin: 0;\n}\n\n/* Elementos del submenú */\n.submenu-item {\n  padding: 20px 20px;\n  font-size: 14px;\n  color: #333;\n  white-space: nowrap;\n}\n\n.submenu-item:hover {\n  background-color: #f0f0f0;\n  color: #0027f9 !important;\n}\n\n.submenu-link {\n  text-decoration: none;\n  color: #0027F9 !important;\n  font-weight: 400;\n}\n\n.menu-content {\n  display: flex;\n  position: absolute;\n  top: 150%;\n  left: -50px;\n  background: #fff;\n  border-radius: 32px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  z-index: 1000;\n  width: 700px;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0.3s, opacity 0.3s;\n}\n\n.menu-item:hover .menu-content {\n  visibility: visible;\n  opacity: 1;\n}\n\n.menu-item:hover .menu-link::after {\n  visibility: visible;\n  opacity: 1;\n}\n\n.menu-content-left {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  /* align-items: center; */\n  text-align: left;\n  padding: 50px 40px;\n  background: rgba(246, 246, 246, 0.90);\n  max-width: 300px;\n}\n\n.menu-content-left-title {\n  color: #0027F9;\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%; /* 24px */\n  letter-spacing: -0.352px;\n}\n\n.menu-logo {\n  width: 130px;\n  border-radius: 16px;\n  margin-bottom: 10px;\n}\n\n.menu-title {\n  font-weight: bold;\n  margin-bottom: 5px;\n  color: #0027F9;\n}\n\n.menu-description {\n  font-size: 14px;\n  /* color: #555; */\n}\n\n.menu-content-right {\n  display: flex;\n  flex-direction: column;\n  background: rgba(254, 254, 254, 0.9);\n  backdrop-filter: blur(20px);\n  padding: 50px 40px;\n}\n\n.menu-curve {\n  position: absolute;\n  bottom: -25px; /* Ajusta esta distancia para alinear con el menú */\n  left: 0;\n  width: 100%;\n  height: 25px;\n  overflow: hidden;\n}\n\n.menu-curve svg {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.mobile-menu-actions .login-btn {\n  height: 64px;\n}\n\n.header-buttons .button-yellow-sm-500, .header-buttons .login-btn, .header-buttons .language-btn {\n  height: 40px;\n}\n\n\n.header-buttons .language-btn .ant-select-selection-item::before {\n  content: \"\";\n  background-image: url('../media/images/world.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  display: inline-block;\n  position: relative;\n  top: 3px;\n}\n\n.language-btn > .ant-select-selector {\n  color: #0027F9;\n}\n\n.header-buttons .language-btn .ant-select-selection-item::after, .mobile-menu-actions .language-btn .ant-select-selection-item::after {\n  content: \">\";\n  margin-left: 8px;\n  transform: rotate(90deg);\n  display: inline-block;\n  font-size: 16px;\n}\n\n/* Ancho y espaciado general */\n.menu-content.markets-menu .menu-content-right {\n  display: flex;\n  gap: 40px;\n}\n\n/* Cada columna de región */\n.region-column {\n  flex: 1;\n}\n\n/* Título de la región */\n.region-column-title {\n  color: #0027F9;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 16px;\n  text-transform: uppercase;\n}\n\n/* Lista de mercados dentro de la región */\n.region-items {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.region-items .submenu-item {\n  padding: 8px 0;\n}\n\n\n/* Título de la región */\n.region-column-title {\n  color: #0027F9;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 16px;\n  text-transform: uppercase;\n}\n\n/* Grid de 3 columnas para los países */\n.region-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px 24px;  /* fila x columna */\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Ajustes a cada elemento de país */\n.region-grid .submenu-item {\n  padding: 4px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
